import axios from 'axios';
import Cookies from 'js-cookie';

// API base URL - always use direct URL
const BASE_URL = 'https://api.tazatropics.com/public/api/';

// Helper to convert object to URLSearchParams - matching Pure Meat's JSON_to_URLEncoded
export const toFormData = (element, key = null, list = []) => {
  if (typeof element === 'object' && element !== null && !(element instanceof Date)) {
    for (let idx in element) {
      toFormData(
        element[idx],
        key ? `${key}[${idx}]` : idx,
        list
      );
    }
  } else {
    list.push(`${key}=${encodeURIComponent(element)}`);
  }
  return list.join('&');
};

// Centralized API call function with common headers and error handling
export const apiCall = async (method, endpoint, data = null, token = null, timeout = 10000) => {
  try {
    const authToken = token || Cookies.get('authToken');
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    const config = {
      method,
      url: `${BASE_URL}${endpoint}`,
      headers,
      timeout
    };

    if (data && (method === 'post' || method === 'put')) {
      config.data = toFormData(data);
    }

    const response = await axios(config);
    return { success: true, data: response.data };
  } catch (error) {
    console.error(`API ${method.toUpperCase()} ${endpoint} error:`, error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Network error. Please try again.',
      status: error.response?.status
    };
  }
};